module.exports = __webpack_public_path__ + "static/media/4.980d2b7a.mp3";